module.exports = __webpack_public_path__ + "img/c656b8e.jpg";